<template>
  <div class="d-flex flex-column gap-4">
    <MyResourceRequest v-if="hasPermission(8388608)" />
    <ManageResourceRequest v-if="hasPermission(16777216)" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MyResourceRequest from "@/components/admin/resourceRequest/MyResourceRequest.vue";
import ManageResourceRequest from "@/components/admin/resourceRequest/ManageResourceRequest.vue";

export default {
  name: "ResourceRequest",
  metaInfo: {
    title: "Solicitação de Recurso",
  },
  components: {
    MyResourceRequest,
    ManageResourceRequest,
  },
  computed: {
    ...mapGetters("auth", ["hasPermission"]),
  },
};
</script>
